import { Popover } from '@mui/material';
import React, { useState } from 'react';

const MyPopover = ({
    name = "my",
    children,
    width = 300,
    anchorOrigin = { vertical: "bottom", horizontal: "right" },
    transformOrigin = { vertical: "top", horizontal: "right" },
    trigger = () => {}
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const id = open ? `${name}-popover` : undefined;

    const handleOpen = (event) => {
        event.preventDefault();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            {trigger(handleOpen)}
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={anchorOrigin}
                transformOrigin={transformOrigin}
                sx={{
                    "& .MuiPopover-paper": {
                        width,
                    },
                }}
            >
                {children}
            </Popover>
        </>
    );
}

export default MyPopover;
